"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useEffect, useState, useSyncExternalStore, type ReactNode } from "react";
import { createHologramStore } from "./hologramStore";
const context = createContext<ReturnType<typeof createHologramStore> | null>(null);

// Hover selection belongs to the laptop hologram, not to galaxy/banner settings.
// Action-only consumers (especially routing) must not subscribe to selection.
export const HologramProvider = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [store] = useState(createHologramStore);
  let t1;
  if ($[0] !== store.cancelPending) {
    t1 = () => store.cancelPending;
    $[0] = store.cancelPending;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== store) {
    t2 = [store];
    $[2] = store;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== children || $[5] !== store) {
    t3 = <context.Provider value={store}>{children}</context.Provider>;
    $[4] = children;
    $[5] = store;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const useHologramActions = () => {
  const actions = useContext(context);
  if (!actions) {
    throw new Error("Hologram actions require HologramProvider");
  }
  return actions;
};
export const useCurrentHologram = () => {
  const store = useHologramActions();
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getServerSnapshot);
};